'use strict';

/* eslint no-undef: "off" */
/**
 * blog list 入口文件
 */
define('blogListApp',['headerWrapper', 'footerWrapper', 'blogListMain', 'searchPanel'], function (headerWrapper, footerWrapper, blogListMain, searchPanel) {
  return {
    template: '\n      <div class="page-container blog-list-page">\n          <header-wrapper></header-wrapper>\n          <blog-list-main></blog-list-main>\n          <footer-wrapper></footer-wrapper>\n          <search-panel></search-panel>\n      </div>\n    ',
    components: {
      headerWrapper: headerWrapper,
      footerWrapper: footerWrapper,
      blogListMain: blogListMain,
      searchPanel: searchPanel
    }
  };
});
